<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="550px"
    class="edit-modal"
    @close="onChange"
  >
    <div slot="title">
      {{
        drawRow.type === 'add'
          ? $t('shop-site::google_manager::add_title')
          : $t('shop-site::google_manager::edit_title')
      }}
      <span v-show="drawRow.type === 'add'">
        <i class="icon-a-01wenhao iconfont-el"></i>
        <el-button type="text" @click="toGuider" style="font-size: 12px">谷歌广告账号绑定教程</el-button>
      </span>
    </div>

    <el-form class="user-body" ref="form" :model="params" :rules="rules" label-width="140px" v-loading="loading">
      <el-form-item :label="$t('shop-site::google::table_shop') + '：'" prop="shopId">
        <el-select
          :popper-append-to-body="false"
          v-model="params.shopId"
          filterable
          class="input-item"
          :placeholder="$t('shop-site::google::placeholder_searchShop')"
          ref="shopSelect"
        >
          <el-option v-for="item in shopIds" :key="item.value" :label="item.label" :value="item.value"></el-option>
          <template slot="empty">
            <div class="empty-wrap">
              {{ $t('shop-site::google_manager::dialog_noData') }}
              <el-button type="text" style="margin-left: 10px" @click="toBindShop">
                {{ $t('shop-site::google_manager::dialog_bind') }}
              </el-button>
            </div>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('shop-site::google::table_manager') + '：'" prop="accountId">
        <el-select
          :popper-append-to-body="false"
          v-model="params.accountId"
          filterable
          class="input-item"
          :placeholder="$t('shop-site::google_manager::placeholder_accountId')"
          style="width: 94%"
        >
          <el-option v-for="item in accountList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <i class="iconfont iconadd" @click="showAddManager = true"></i>
        <template #error="{ error }">
          <div class="el-form-item__error">
            {{ error }}
            <el-button
              v-show="error === '该经理账号未授权'"
              type="text"
              style="padding: 0; font-size: 12px"
              @click="accountEmpower(params.accountId)"
            >
              重新授权
            </el-button>
          </div>
        </template>
      </el-form-item>
      <el-form-item :label="$t('shop-site::google::table_child') + '：'" prop="customerId">
        <el-input
          :placeholder="$t('shop-site::google_manager::placeholder_customerId')"
          class="input-item"
          v-model="params.customerId"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="saveLoading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
    <EditDialog ref="edit" :isNew="true" @editAndadd="getShopListInfo"></EditDialog>
    <editManagerModal v-model="showAddManager" :drawRow="{ type: 'add' }" @save="getManagerList"></editManagerModal>
  </el-dialog>
</template>
<script>
import { getGoogleManagerList, setGoogleAccount, accountEmpower } from '@/server/marketing.js'
import { getShopList, getErpShopList } from '@/server/shopList.js'
import editManagerModal from './edit-manager-modal'
import EditDialog from '@/views/store/components/editDialog'
export default {
  name: 'edit-modal',
  components: { EditDialog, editManagerModal },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.drawRow
      if (bool) {
        this.getShopListInfo()
        this.getManagerList()
      }
      if (data.type === 'add') {
        this.params = {
          shopId: '',
          id: null,
          accountId: '',
          customerId: '',
        }
      } else {
        this.params = {
          shopId: data.item.shopId,
          id: data.item.id,
          accountId: data.item.accountId,
          customerId: data.item.customerId,
        }
      }

      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true,
    },
  },
  data() {
    var checkAccoutId = (rule, value, callback) => {
      if (value) {
        let arr = this.accountList.find(el => value === el.value)
        console.log(arr)
        if (arr && !arr.status) {
          callback('该经理账号未授权')
        } else {
          callback()
        }
      } else {
        callback(this.$t('shop-site::google_manager::placeholder_accountId'))
      }
    }
    return {
      loading: false,
      saveLoading: false,
      showAddManager: false,
      shopIds: [],
      accountList: [],
      rules: {
        shopId: [{ required: true, message: this.$t('shop-site::google::placeholder_searchShop'), trigger: 'change' }],
        accountId: [
          // {  message: this.$t('shop-site::google_manager::placeholder_accountId'), trigger: 'change' },
          { required: true, trigger: 'change', validator: checkAccoutId },
        ],
        customerId: [
          { required: true, message: this.$t('shop-site::google_manager::placeholder_customerId'), trigger: 'blur' },
        ],
      },
      show: false,
      params: {},
      merchantId: this.$store.state.user.merchantId,
    }
  },
  mounted() {},
  computed: {
    sourceType() {
      return this.$store.state.user.sourceType
    },
  },
  methods: {
    toGuider() {
      window.open('https://docs.qq.com/doc/DTGxLeVJnR0ZkZ0hx', '_blank')
    },
    async getShopListInfo() {
      this.loading = true
      if (this.sourceType === 1) {
        const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
        if (data.code === this.$code) {
          this.shopIds = data.data.items.map(item => {
            return {
              label: item.name,
              value: item.id,
            }
          })
        }
      } else if (this.sourceType === 2) {
        const { data } = await getErpShopList(this.merchantId)
        if (data.code === this.$code) {
          this.shopIds = data.data.map(item => {
            return {
              label: item.shopName,
              value: item.shopId,
            }
          })
        }
      }
      // const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
      // if (data.code === this.$code && data.data.items) {
      //   console.log(data)
      //   this.shopIds = data.data.items.map(item => {
      //     return {
      //       label: item.name,
      //       value: item.id
      //     }
      //   })
      // }
      this.loading = false
    },
    async getManagerList() {
      this.loading = true
      const { data } = await getGoogleManagerList()
      if (data.code === this.$code && data.data) {
        console.log(data)
        this.accountList = data.data.map(item => {
          return {
            label: item.customerId,
            value: item.id,
            status: item.status,
          }
        })
      }
      this.loading = false
    },
    async accountEmpower(id) {
      const { data } = await accountEmpower(id)
      if (data.code === this.$code) {
        window.location.href = data.data
      }
    },
    onChange() {
      this.$emit('change', false)
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.saveLoading = true
          let params = {
            ...this.params,
          }
          if (this.drawRow.type === 'add') {
            delete params.id
          }
          const { data } = await setGoogleAccount(params)
          if (data.code === this.$code) {
            if (this.drawRow.type === 'add') {
              await this.$store.dispatch('getBindData')
            }
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save')
            this.$emit('change', false)
          }
          this.saveLoading = false
        }
      })
    },
    handleCheck(type) {
      this.$refs.form.resetFields()
      this.params.type = type
    },
    toBindShop() {
      this.$refs.shopSelect.blur() // 失焦隐藏下拉框
      this.$refs.edit.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-modal {
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
.empty-wrap {
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.icon-a-01wenhao {
  margin-left: 5px;
  font-size: 12px;
  color: #999;
}
.iconadd {
  margin-left: 5px;
  font-size: 16px;
  color: #dcdfe6;
  cursor: pointer;
  line-height: 31px;
}
</style>
